export default __webpack_public_path__ + "static/media/Anwesh-Gangula.5ac81d10.webp";